<template>
    <div>
        <h2 class="create-asset__heading heading heading--lg">
            {{ isNew ? 'Add a thumbnail' : 'Thumbnail' }}
            <div class="badge badge--red">JPEG</div>
            <div class="badge badge--green">PNG</div>
        </h2>

        <SingleFileUpload
            :error-messages="uploadThumbnailErrorMessages"
            :default-value="defaultThumbnailSrc"
            :file-item="uploadedThumbnail"
            :upload-in-progress="uploadThumbnailInProgress"
            :max-file-size="2"
            file-type="images"
            element-name="thumbnail-file"
            @removed="removeThumbnail"
            @upload-complete="onUploadThumbnailComplete"
        />
            <!-- :file-item-loading="uploadedThumbnail" -->
            <!-- @upload-progress="onUploadThumbnailProgress" -->
            <!-- @upload-started="onUploadThumbnailStarted" -->
    </div>
</template>
<script>
import { addInfoNotification } from '../../lib/notifications';
import SingleFileUpload from './SingleFileUpload.vue';
import CreateOrEditAssetMixin from '../../mixins/CreateOrEditAssetMixin';

import { mapGetters } from 'vuex';

export default {
    components: {
        SingleFileUpload,
    },
    props: {
        asset: {
            type: Object,
            default: () => {},
        },
        isNew: {
            type: Boolean,
            default: true,
        },
        listeners: {
            type: Object,
            default: () => {},
        },
    },
    mounted() {
        this.uploadedThumbnail = this.asset.thumbnail
            ? this.asset.thumbnail
            : null;
    },
    data() {
        return {
            defaultThumbnailSrc: '',
            thumbnailFile: null,
            uploadedThumbnail: [],
            uploadThumbnailInProgress: false,
            uploadThumbnailErrorMessages: [],
        };
    },
    mixins: [CreateOrEditAssetMixin],
    watch: {
        asset(newAsset, oldAsset) {
            if (newAsset?.thumbnail?.file_id) {
                this.defaultThumbnailSrc =  `/api/images/${newAsset.thumbnail.file_id}?width=150&type=jpg`;
            }
        }
    },
    computed: {
          ...mapGetters('settings', {
            previewSizes: 'previewSizes',
            thumbnailsUrl: 'thumbnailsUrl',
            webpSuppport: 'webp',
        }),
    },
    methods: {

        isValid(thumbnail) {
            return !!thumbnail;
        },
        async removeThumbnail() {
            this.setNotification('Thumbnail was deleted');

            // this.asset.thumbnail = null;

            // await AssetResource.removeThumbnail(this.asset.id);

            // this.listeners.change({
            //     thumbnail: null,
            //     valid: this.isValid(null),
            // });
        },
   
        onUploadThumbnailComplete(file) {
            // this.uploadThumbnailErrorMessages = [];
            let validThumbnails = this.fileMapper(
                file,
                this.uploadThumbnailErrorMessages
            );
            this.uploadedThumbnail = validThumbnails
            this.listeners.change({
                thumbnail: validThumbnails,
                valid: this.isValid(validThumbnails),
            });
        },

        fileMapper(file, errorMessages) {
            let _file = {
                name: file.fileName,
                url: file.url,
                file_id: file.id,
                data: {
                    formData: file.formData,
                    type: 'image',
                    name: file.fileName,
                    file_id: file.id,
                },
            };
            if (file.thumbnails) {
                file.data.thumbnails = file.thumbnails;
            }
            if (file.thumbnail_ids) {
                file.data.thumbnail_ids = file.thumbnail_ids;
            }
            return _file;
        },
        setNotification(message) {
            addInfoNotification(message, {
                timeout: 5000,
            });
        },
    },
};
</script>
